 
import React   from 'react' ;  
const   SiteFooter = ()=>{
 
  
   return (
     <>  
     <div className="row App">
        <hr/>
     <p>site Footer </p>
      </div>
     </>
   )
    
} 
export default SiteFooter